import { render, staticRenderFns } from "./intangibleCultural.vue?vue&type=template&id=a90885a4&scoped=true"
import script from "./intangibleCultural.vue?vue&type=script&setup=true&lang=js"
export * from "./intangibleCultural.vue?vue&type=script&setup=true&lang=js"
import style0 from "./intangibleCultural.vue?vue&type=style&index=0&id=a90885a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90885a4",
  null
  
)

export default component.exports